import { APIClient } from '@frontend/api-utils';

export class ProblemEnumClient extends APIClient {
    public static readonly endpoint = '/problem-api/v1';

    public static async fetchProblemEntityTypes(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/problem-entity-types`);
        return await this.handleResponse<string[]>(response);
    }
}
